import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Resolve a stored image reference to a displayable URL.
// Object-storage images are stored as backend-relative paths ("/api/files/...");
// base64 ("data:"), blob and absolute http(s) URLs are returned unchanged.
export function resolveImageUrl(src) {
  if (!src || typeof src !== "string") return src;
  if (src.startsWith("http") || src.startsWith("data:") || src.startsWith("blob:")) return src;
  if (src.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  return src;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatPrice(price, category) {
  if (category === "Jobs") return "See listing";
  if (price === 0) return "€0";
  const formatted = "€" + Number(price).toLocaleString("en-IE");
  return category === "Lettings" ? `${formatted} / month` : formatted;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

export default api;
